(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9240],{

/***/ 23646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Anchor; }
});

// UNUSED EXPORTS: isTrivialHref

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js
var esm_useCommittedRef = __webpack_require__(92029);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var esm_useEventCallback = __webpack_require__(78146);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventListener.js



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = useEventCallback(listener);
  useEffect(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = useCallback(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useInterval.js


/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

function useInterval(fn, ms, paused, runImmediately) {
  if (paused === void 0) {
    paused = false;
  }

  if (runImmediately === void 0) {
    runImmediately = false;
  }

  var handle;
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  var tick = function tick() {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  var schedule = function schedule() {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };

  useEffect(function () {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }

    return function () {
      return clearTimeout(handle);
    };
  }, [paused, runImmediately]);
}

/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useRafInterval.js



function useRafInterval(fn, ms, paused) {
  if (paused === void 0) {
    paused = false;
  }

  var handle;
  var start = new Date().getTime();
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  function loop() {
    var current = new Date().getTime();
    var delta = current - start;
    if (pausedRef.current) return;

    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }

    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }

  useEffect(function () {
    handle = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(handle);
    };
  }, []);
}

/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeState.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var updater = useCallback(function (update) {
    if (update === null) return;

    if (typeof update === 'function') {
      setState(function (state) {
        var nextState = update(state);
        return nextState == null ? state : _extends({}, state, nextState);
      });
    } else {
      setState(function (state) {
        return _extends({}, state, update);
      });
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
      state = _useMergeState[0],
      setState = _useMergeState[1];

  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(88833);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useImage.js


/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  var _useState = useState({
    image: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!imageOrUrl) return undefined;
    var image;

    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;

      if (image.complete && image.naturalHeight > 0) {
        setState({
          image: image,
          error: null
        });
        return;
      }
    }

    function onLoad() {
      setState({
        image: image,
        error: null
      });
    }

    function onError(error) {
      setState({
        image: image,
        error: error
      });
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return function () {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

var isReactNative = typeof __webpack_require__.g !== 'undefined' && // @ts-ignore
__webpack_require__.g.navigator && // @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */

/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useResizeObserver.js


var targetMap = new WeakMap();
var resizeObserver;

function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}
/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */


function useResizeObserver(element) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, function (rect) {
      setRect(rect);
    });
    return function () {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/index.js














// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(70861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const _excluded = ["onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-has-content */




function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps] = (0,Button/* useButtonProps */.FT)(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = (0,esm_useEventCallback/* default */.Z)(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });

  if (isTrivialHref(props.href) && !props.role || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);

/***/ }),

/***/ 93592:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/study-abroad-scholarships",
      function () {
        return __webpack_require__(59040);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76604);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14523);





const Banner = ({ children , bannerData , bgInverted =false , bannerStyles ={} , imageWrapperStyles ={}  })=>{
    const isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(768);
    const bannerImageData = !isMobile ? bannerData?.priorityImage : bannerData?.priorityImageMobile;
    const { 0: aspectRatio , 1: setAspectRatio  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAspectRatio(null);
        const url = bannerImageData?.url;
        if (isMobile || !url) return;
        const img = new window.Image();
        const onLoad = ()=>{
            if (img.naturalWidth && img.naturalHeight) {
                setAspectRatio(img.naturalWidth / img.naturalHeight);
            }
        };
        img.addEventListener("load", onLoad);
        img.src = url;
        return ()=>img.removeEventListener("load", onLoad);
    }, [
        bannerImageData?.url,
        isMobile
    ]);
    const imageClickHandler = (url)=>()=>{
            window.open(url ?? "", "_blank");
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: bannerImageData?.url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["image-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)",
                ...imageWrapperStyles
            },
            onClick: imageClickHandler(bannerData?.priorityImageUrl ?? ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image-container"]),
                style: !isMobile && aspectRatio ? {
                    aspectRatio: String(aspectRatio),
                    height: "auto"
                } : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: bannerImageData?.url ?? "/images/man_with_foldedhands.png",
                    alt: bannerData?.title ?? "banner-image",
                    layout: "fill",
                    objectFit: isMobile ? "fill" : "contain",
                    className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["priority-image"]),
                    priority: true,
                    isLazyLoad: false
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container-wrapper"]),
            style: {
                background: "linear-gradient(to bottom, #ffffff 50%, #ffffff 50%)"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["banner-container"]),
                style: bannerStyles,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 55689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34051);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70710);













const VideoTestimonials = (props)=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial, secondVideoTestimonial)=>secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
    const videosCount = props.testimonialVideos?.length || 0;
    const videosSlidersettings = {
        infinite: videosCount > 3,
        arrows: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 1,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: videosCount > 2,
                    autoplay: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderDots),
                    infinite: videosCount > 1,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievements),
        style: {
            backgroundColor: props.sectionBgColor || "#ffffff",
            ...props?.parentContainerStyles ?? {}
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().containerDiv),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().heading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description),
                                children: props.subTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sliderContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                ...videosSlidersettings,
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider),
                                ref: sliderRef,
                                children: limitedTestimonials?.length > 0 && limitedTestimonials?.map((content, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().achievementsDiv),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                    width: "33",
                                                    height: "22",
                                                    viewBox: "0 0 33 22",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                            fill: "#226CF5"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            clipRule: "evenodd",
                                                            d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                            fill: "#226CF5"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().videoDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        iframeClassName: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().studVideo),
                                                        src: content.videoLink,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        children: content.name
                                                    }),
                                                    content?.designation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.designation
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: content.university
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            props.testimonialVideos?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowsClass),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btcircle),
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoTestimonials);


/***/ }),

/***/ 78808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _CountryDetail_Banner_Banner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74623);
/* harmony import */ var _Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85307);
/* harmony import */ var _Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45992);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);






function Banner1({ bannerData  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-section-wrapper"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-container"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CountryDetail_Banner_Banner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bannerData: bannerData,
                imageWrapperStyles: {
                    margin: "0"
                },
                bannerStyles: {
                    backgroundColor: "#6C48F0",
                    width: "100%",
                    margin: "-80px 0"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["banner-1-container"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["content-container"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: bannerData?.title ?? ""
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["actions-container"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["kc-letter-container"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: "/icons/kc_union.svg",
                                        height: 187,
                                        width: 325,
                                        alt: "kc-overseas-icon",
                                        objectFit: "fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: `${(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["contact-us-btn"])} ${bannerData?.button1?.btnLink ? "" : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(bannerData?.button1?.formId ?? "")}`,
                                    onClick: ()=>{
                                        bannerData?.button1?.btnLink && window.open(bannerData?.button1?.btnLink, "_blank");
                                    },
                                    children: bannerData?.button1?.btnTitle ?? ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: `${(_Banner1_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["enquire-now-btn"])} ${bannerData?.button2?.btnLink ? "" : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(bannerData?.button2?.formId ?? "")}`,
                                    onClick: ()=>{
                                        bannerData?.button2?.btnLink && window.open(bannerData?.button2?.btnLink, "_blank");
                                    },
                                    children: bannerData?.button2?.btnTitle ?? ""
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Banner1);


/***/ }),

/***/ 57866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20252);
/* harmony import */ var _FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33434);




const FAQs = ({ faqData  })=>{
    const accordionItems = (faqData?.faqPoints ?? []).map((faq)=>({
            title: faq.title,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: faq.description
                }
            })
        }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-section"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-heading"]),
                    children: faqData?.title ?? ""
                }),
                faqData?.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_FAQs_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["faq-subtext"]),
                    dangerouslySetInnerHTML: {
                        __html: faqData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Accordion_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    items: accordionItems,
                    defaultOpenIndex: 0,
                    theme: "base",
                    icon: "plus"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 64171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56303);
/* harmony import */ var _ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14523);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89382);






const ReceviedScholarships = ({ topScholarships  })=>{
    const isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(768);
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        loop: false,
        align: "start"
    });
    const { 0: selectedIndex , 1: setSelectedIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { 0: scrollSnaps , 1: setScrollSnaps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        const onSelect = ()=>setSelectedIndex(emblaApi.selectedScrollSnap());
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        onSelect();
        return ()=>{
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [
        emblaApi
    ]);
    const goToPrev = ()=>emblaApi?.scrollPrev();
    const goToNext = ()=>emblaApi?.scrollNext();
    const goToSnap = (index)=>emblaApi?.scrollTo(index);
    const arrowLeft = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow"]),
        onClick: goToPrev,
        "aria-label": "Previous",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/new-images/left-arrow.svg",
            height: 17,
            width: 10,
            alt: "left-arrow"
        })
    });
    const arrowRight = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow"]),
        onClick: goToNext,
        "aria-label": "Next",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/new-images/right-arrow.svg",
            height: 17,
            width: 10,
            alt: "right-arrow"
        })
    });
    const renderCards = ()=>topScholarships?.ourStudentsAchievements?.map((recipient)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-slide"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-card"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-avatar-wrap"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: recipient.studentImageUrl || "/new-images/for-student.svg",
                                alt: recipient.name,
                                width: 160,
                                height: 160,
                                objectFit: "cover",
                                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-avatar"])
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-name"]),
                            children: recipient.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-details"]),
                            children: recipient?.points?.length > 0 && recipient?.points?.map((point)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-label"]),
                                            children: [
                                                point.label,
                                                " :"
                                            ]
                                        }),
                                        " ",
                                        point.value
                                    ]
                                }))
                        })
                    ]
                })
            }, recipient.id));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-section"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-heading"]),
                    children: topScholarships?.title ?? ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-carousel-wrap"]),
                    children: [
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow-side"]),
                            children: arrowLeft
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-viewport"]),
                            ref: emblaRef,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-slider"]),
                                children: renderCards()
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrow-side"]),
                            children: arrowRight
                        })
                    ]
                }),
                isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-arrows-below"]),
                    children: [
                        arrowLeft,
                        arrowRight
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dots"]),
                    children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: `${(_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dot"])} ${index === selectedIndex ? (_ReceviedScholarships_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["rs-dot-active"]) : ""}`,
                            onClick: ()=>goToSnap(index),
                            "aria-label": `Go to slide ${index + 1}`
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReceviedScholarships);


/***/ }),

/***/ 31010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Kunai = ({ width =20 , height =20 , color ="#ffffff"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.34317 0.633099C7.6761 -0.211047 8.87078 -0.211046 9.2037 0.633099L10.9425 5.04193C11.0442 5.29965 11.2482 5.50366 11.5059 5.6053L15.9147 7.34412C16.7589 7.67705 16.7589 8.87172 15.9147 9.20465L11.5059 10.9435C11.2482 11.0451 11.0442 11.2491 10.9425 11.5068L9.2037 15.9157C8.87078 16.7598 7.6761 16.7598 7.34317 15.9157L5.60436 11.5068C5.50271 11.2491 5.29871 11.0451 5.04098 10.9435L0.632153 9.20465C-0.211993 8.87172 -0.211993 7.67705 0.632153 7.34412L5.04098 5.6053C5.29871 5.50366 5.50271 5.29965 5.60436 5.04193L7.34317 0.633099Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Kunai);


/***/ }),

/***/ 59040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ study_abroad_scholarships; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/ScholarshipsPage/HeroSection/HeroSection.module.scss
var HeroSection_module = __webpack_require__(34641);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(14523);
// EXTERNAL MODULE: ./components/UI/Icons/Kunai.tsx
var Kunai = __webpack_require__(31010);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/HeroSection/HeroSection.tsx








const HeroSection = ({ scholarshipData  })=>{
    const isMobile = (0,useIsMobile/* default */.Z)(768);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (HeroSection_module_default())["hero-section-wrapper"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "sholarships-page",
                className: (HeroSection_module_default()).heroSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroSection_module_default())["hero-content"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default())["breadcrum-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            style: {
                                                opacity: 0.5
                                            },
                                            href: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            href: "",
                                            children: "Scholarships"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: scholarshipData?.heroSection?.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: scholarshipData?.heroSection?.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: `${(HeroSection_module_default())["cta-button"]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipData?.meta?.jotforms[0]?.jotformid ?? "")}`,
                                children: scholarshipData?.heroSection?.ctaBtn?.btnTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroSection_module_default())["images-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default())["bg-circle"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HeroSection_module_default())["column-1"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroSection_module_default())["image-container-1"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: scholarshipData?.heroSection?.imageUrl1,
                                            alt: scholarshipData?.heroSection?.image1Alt ?? "hero-img",
                                            width: isMobile ? 146 : 200,
                                            height: isMobile ? 119 : 160,
                                            objectFit: "fill"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HeroSection_module_default())["image-container-2"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: scholarshipData?.heroSection?.imageUrl3,
                                            alt: scholarshipData?.heroSection?.image3Alt ?? "hero-img",
                                            objectFit: "fill",
                                            width: isMobile ? 146 : 200,
                                            height: isMobile ? 167 : 230
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSection_module_default())["column-2-wrapper"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HeroSection_module_default())["column-2"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSection_module_default())["image-container-1"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: scholarshipData?.heroSection?.imageUrl2,
                                                alt: scholarshipData?.heroSection?.image2Alt ?? "hero-img",
                                                width: isMobile ? 146 : 205,
                                                height: isMobile ? 167 : 235,
                                                objectFit: "fill"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSection_module_default())["image-container-2"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: scholarshipData?.heroSection?.imageUrl4,
                                                alt: scholarshipData?.heroSection?.image4Alt ?? "hero-img",
                                                width: isMobile ? 146 : 205,
                                                height: isMobile ? 119 : 168,
                                                objectFit: "fill"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeroSection_module_default())["star-container-layer"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["star-1"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["star-2"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["star-3"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Kunai/* default */.Z, {
                            color: "#ffffff80"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["empty-hole"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["dot-1"]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default())["dot-2"]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HeroSection_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./components/ScholarshipsPage/CardsSection/CardsSection.module.scss
var CardsSection_module = __webpack_require__(95316);
var CardsSection_module_default = /*#__PURE__*/__webpack_require__.n(CardsSection_module);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
// EXTERNAL MODULE: ./components/UI/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(20052);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/CardsSection/CardsSection.tsx







const Card = ({ showcaseCard , title , scholarshipData , slug , ...props })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CardsSection_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CardsSection_module_default())["card-image"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                    src: showcaseCard?.cardImg?.url ?? "/images/default-intake-bg.jpg",
                    alt: title ?? "",
                    layout: "fill",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CardsSection_module_default())["card-content"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (CardsSection_module_default())["card-title"],
                        children: showcaseCard?.title ?? ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CardsSection_module_default())["card-buttons"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (CardsSection_module_default())[`card-button-outline`],
                                href: `/student-services/study-abroad-scholarships/${slug}`,
                                target: "_blank",
                                children: "Know More"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: `${(CardsSection_module_default())[`card-button-gradient`]} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(scholarshipData?.meta?.jotforms?.[0]?.jotformid ?? undefined)}`,
                                children: "Apply Now"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const CardsSection = ({ scholarshipData , countryCardsData , countrySpecificScholarshipsData  })=>{
    const { 0: visibleCount , 1: setVisibleCount  } = (0,react.useState)(21);
    const { 0: selectedCountry , 1: setSelectedCountry  } = (0,react.useState)(null);
    const { 0: filteredCards , 1: setFilteredCards  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setVisibleCount(21);
        setFilteredCards(countrySpecificScholarshipsData ?? []);
    }, [
        scholarshipData
    ]);
    const selectHandler = (option)=>{
        setFilteredCards((prev)=>countrySpecificScholarshipsData?.filter((country)=>country?.scholarships_country?.countryName === option.value));
        setSelectedCountry(option);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (CardsSection_module_default())["cards-section-wrapper"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CardsSection_module_default())["cards-section-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (CardsSection_module_default())["section-heading"],
                    children: countryCardsData?.title ?? ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default())["section-description"],
                    dangerouslySetInnerHTML: {
                        __html: countryCardsData?.description ?? ""
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default())["dropdown-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                        options: countrySpecificScholarshipsData?.filter((country)=>!!country?.scholarships_country?.countryName).map((country)=>({
                                label: country.scholarships_country?.countryName ?? "",
                                value: country.scholarships_country?.countryName ?? ""
                            })) ?? [],
                        onChange: selectHandler,
                        placeholder: "Select Country",
                        value: selectedCountry,
                        showClear: true,
                        onClear: ()=>{
                            setSelectedCountry(null);
                            setFilteredCards(countrySpecificScholarshipsData);
                        },
                        searchable: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default())["cards-container"],
                    children: filteredCards?.length > 0 && filteredCards?.slice(0, visibleCount).map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                            scholarshipData: scholarshipData,
                            ...card
                        }, index))
                }),
                filteredCards?.length > visibleCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (CardsSection_module_default())["view-more-btn"],
                    onClick: ()=>setVisibleCount((count)=>count + 21),
                    children: [
                        "View More",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            color: "#FF7361",
                            width: 6,
                            height: 10
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CardsSection_CardsSection = (CardsSection);

// EXTERNAL MODULE: ./components/ScholarshipsPage/ReceviedScholarships/ReceviedScholarships.tsx
var ReceviedScholarships = __webpack_require__(64171);
// EXTERNAL MODULE: ./components/ScholarshipsPage/FAQs/FAQs.tsx
var FAQs = __webpack_require__(57866);
// EXTERNAL MODULE: ./components/ScholarshipsPage/Banner1/Banner1.tsx
var Banner1 = __webpack_require__(78808);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
;// CONCATENATED MODULE: ./components/ScholarshipsPage/ScholarshipPage.tsx








const ScholarshipPage = (props)=>{
    const scholarshipData = props?.pageData ?? {};
    const topScholarships = props?.pageData?.topScholarships ?? {};
    const countryCardsData = props?.pageData?.countryCards ?? {};
    const countrySpecificScholarshipsData = props?.countrySpecificScholarshipsData ?? {};
    const faqData = props?.pageData?.faq ?? {};
    const bannerData = props?.pageData?.banner ?? {};
    const hasData = (obj)=>Object.keys(obj).length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection_HeroSection, {
                scholarshipData: scholarshipData
            }),
            hasData(countryCardsData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection_CardsSection, {
                scholarshipData: scholarshipData,
                countryCardsData: countryCardsData,
                countrySpecificScholarshipsData: countrySpecificScholarshipsData
            }),
            hasData(topScholarships) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceviedScholarships/* default */.Z, {
                topScholarships: topScholarships
            }),
            props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "-30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                    ...props.pageData.videoTestimonial
                })
            }),
            hasData(faqData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                faqData: faqData
            }),
            hasData(bannerData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner1/* default */.Z, {
                bannerData: bannerData
            })
        ]
    });
};
/* harmony default export */ var ScholarshipsPage_ScholarshipPage = (ScholarshipPage);

;// CONCATENATED MODULE: ./pages/student-services/study-abroad-scholarships.tsx




const Scholarships = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#226CF5");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScholarshipsPage_ScholarshipPage, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var study_abroad_scholarships = (Scholarships);


/***/ }),

/***/ 76604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner_hide-scrollbar__wUm_f","banner-container-wrapper":"Banner_banner-container-wrapper__FH34m","banner-container":"Banner_banner-container__dfXxn","image-wrapper":"Banner_image-wrapper__DbE96","priority-image-container":"Banner_priority-image-container__Eof0j"};

/***/ }),

/***/ 85307:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Banner1_hide-scrollbar__RcLoc","banner-section-wrapper":"Banner1_banner-section-wrapper__grJxN","banner-container":"Banner1_banner-container__n3evD","banner-1-container":"Banner1_banner-1-container__4RUVv","content-container":"Banner1_content-container__rmHkt","actions-container":"Banner1_actions-container__BvVeL","kc-letter-container":"Banner1_kc-letter-container__75B1q","contact-us-btn":"Banner1_contact-us-btn__5M1Nk","enquire-now-btn":"Banner1_enquire-now-btn__9Yq_6"};

/***/ }),

/***/ 95316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"CardsSection_hide-scrollbar__ENz1p","cards-section-wrapper":"CardsSection_cards-section-wrapper__I7QbP","cards-section-container":"CardsSection_cards-section-container__rkDWZ","section-heading":"CardsSection_section-heading__n4aHS","section-description":"CardsSection_section-description__R1_5z","dropdown-container":"CardsSection_dropdown-container__23o4v","cards-container":"CardsSection_cards-container__JFWrk","card":"CardsSection_card__F7wLj","card-image":"CardsSection_card-image__NZd5V","card-content":"CardsSection_card-content__HBe9T","card-title":"CardsSection_card-title__TPexu","card-buttons":"CardsSection_card-buttons__ZauCl","card-button-outline":"CardsSection_card-button-outline__2hESQ","card-button-gradient":"CardsSection_card-button-gradient__sUWKa","view-more-btn":"CardsSection_view-more-btn__PvZPq"};

/***/ }),

/***/ 20252:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"FAQs_hide-scrollbar__89ZH6","faq-section":"FAQs_faq-section__evhQ6","faq-container":"FAQs_faq-container__S5dao","faq-heading":"FAQs_faq-heading__Zbi8v","faq-subtext":"FAQs_faq-subtext__jIOs1"};

/***/ }),

/***/ 34641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"HeroSection_hide-scrollbar__QWkJq","hero-section-wrapper":"HeroSection_hero-section-wrapper__jB5LH","heroSection":"HeroSection_heroSection__7YOi4","hero-content":"HeroSection_hero-content__vnNMR","cta-button":"HeroSection_cta-button__vbsc4","images-container":"HeroSection_images-container__JHE0x","column-1":"HeroSection_column-1__pMZ_c","column-2":"HeroSection_column-2___vvIt","image-container-1":"HeroSection_image-container-1__dRlM7","image-container-2":"HeroSection_image-container-2__JDmzu","column-2-wrapper":"HeroSection_column-2-wrapper__N1oOp","bg-circle":"HeroSection_bg-circle__0otht","star-container-layer":"HeroSection_star-container-layer__5ubn0","star-1":"HeroSection_star-1__kRPa7","star-2":"HeroSection_star-2__I1bPC","star-3":"HeroSection_star-3__FBCwy","empty-hole":"HeroSection_empty-hole__oEH7L","dot-1":"HeroSection_dot-1__atJUe","dot-2":"HeroSection_dot-2__u_1yH"};

/***/ }),

/***/ 56303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"ReceviedScholarships_hide-scrollbar__UdtTB","rs-section":"ReceviedScholarships_rs-section__Y4lAg","rs-container":"ReceviedScholarships_rs-container__JOTI7","rs-heading":"ReceviedScholarships_rs-heading__4wPW7","rs-carousel-wrap":"ReceviedScholarships_rs-carousel-wrap__3R6xK","rs-arrow-side":"ReceviedScholarships_rs-arrow-side__2VJ9_","rs-viewport":"ReceviedScholarships_rs-viewport__tM6xk","rs-slider":"ReceviedScholarships_rs-slider__jkQ55","rs-arrows-below":"ReceviedScholarships_rs-arrows-below__B0RLc","rs-dots":"ReceviedScholarships_rs-dots__LtV2o","rs-dot":"ReceviedScholarships_rs-dot__sc7iL","rs-dot-active":"ReceviedScholarships_rs-dot-active__leLly","rs-slide":"ReceviedScholarships_rs-slide__YuYYX","rs-card":"ReceviedScholarships_rs-card__9xx4Y","rs-avatar-wrap":"ReceviedScholarships_rs-avatar-wrap__WbIAK","rs-avatar":"ReceviedScholarships_rs-avatar__7eFuh","rs-name":"ReceviedScholarships_rs-name__nVn78","rs-details":"ReceviedScholarships_rs-details__pZ_d_","rs-label":"ReceviedScholarships_rs-label__UzNUQ","rs-arrow":"ReceviedScholarships_rs-arrow__aKKjJ"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9382,474,6985,9774,2888,179], function() { return __webpack_exec__(93592); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);